import React from 'react';
import { cx } from './cx';

export const Card = ({ className, children, ...rest }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx('rounded-card border border-line bg-surface shadow-card', className)} {...rest}>
    {children}
  </div>
);

export const CardBody = ({ className, children }: { className?: string; children?: React.ReactNode }) => <div className={cx('p-5', className)}>{children}</div>;
